<template>
  <div v-if="modelValue && network" class="network-preview-overlay" @click.self="close">
    <div class="network-preview-modal" @click.stop>

      <div class="modal-top">
        <img :src="network.logo" class="modal-logo" :alt="`${network.title} logo`">
        <button type="button" class="close-btn" @click="close" aria-label="Close">×</button>
      </div>

      <img :src="network.image" class="modal-image" :alt="network.title" style="width: 549px; height: 308px;">

      <div class="modal-content">
        <p v-html="network.content"></p>

        <div class="modal-links">
          <a :href="network.website" target="_blank" rel="noopener">🌐 Website: {{ network.website }}</a>
          <br v-if="network.extraLink">
          <a v-if="network.extraLink" :href="network.extraLink" target="_blank" rel="noopener">
            👉 Additional Link
          </a>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'NetworkPreviewDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    network: {
      type: Object,
      default: null
    }
  },
  emits: ['update:modelValue'],
  methods: {
    close() {
      this.$emit('update:modelValue', false)
    }
  }
}
</script>

<style scoped>
.network-preview-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
  z-index: 9999;
}

.network-preview-modal {
  background: white;
  border-radius: 18px;
  width: 80%;
  max-width: 1050px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 20px;
  box-shadow: 0px 6px 40px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.3s ease;
  position: relative;
}

.modal-content {
  margin-top: 20px;
}

.modal-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-logo {
  width: 200px;
  object-fit: contain;
}

.close-btn {
  border: none;
  background: transparent;
  font-size: var(--font-size-3xl);
  cursor: pointer;
  color: #333;
}

.modal-image {
  width: 100%;
  border-radius: 14px;
  margin-top: 15px;
  object-fit: cover;
  margin: 15px auto;
  display: block;
}

.modal-content p {
  line-height: var(--line-height-relaxed);
  font-size: var(--font-size-md);
}

.modal-links {
  margin-top: 20px;
}

.modal-links a {
  display: inline-block;
  color: #009CAD;
  font-weight: var(--font-weight-bold);
  text-decoration: none;
}

.modal-links a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .modal-logo {
    width: 140px;
  }

  .network-preview-modal {
    width: 95%;
    padding: 15px;
  }

  .modal-content {
    max-height: calc(90vh - 300px);
  }
}
</style>
